import React from 'react';

import DayOfTheWeekOptions from 'components/DayOfTheWeekOptions';
import { WorksheetType } from 'services/worksheet/types';
import DayOfTheWeekFieldDropdown from './components/DayOfTheWeekFieldDropdown';

interface Props {
    // eslint-disable-next-line react/no-unused-prop-types
    worksheetType: WorksheetType;
}

export default function DayOfTheWeekField(props: Props): React.ReactElement {
    return (
        <DayOfTheWeekOptions
            component={DayOfTheWeekFieldDropdown}
            componentProps={props}
        />
    );
}
